import {
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  asset9,
  asset9Flip,
  asset10,
  asset11,
  lacesSB,
} from './assets'

const assets: any = [
  { src: asset1, x: 0, y: 0, itemId: 101, majorLayer: true },
  { src: asset2, x: -30.195, y: 0.3667 },
  { src: asset3, x: 1178.2581, y: 265.5852, itemId: 102 },
  { src: asset4, x: 24.4407, y: 68.3955, itemId: 106 },
  { src: asset5, x: 150.7926, y: 750.6563 },
  { src: asset6, x: 1076.4069, y: 222.786, itemId: 104 },
  { src: asset7, x: 23.0124, y: 66.045, itemId: 109 },
  { src: asset8, x: 856.5978, y: 128.8002, itemId: 108 },
  {
    src: asset9,
    x: 1243.7556,
    y: 305.1147,
    itemId: 116,
    blendMode: 'no-blend',
    hasFlippedAsset: true,
    flippedAssetIndex: 0,
  },
  {
    src: asset10,
    x: 334.0068,
    y: 737.2491,
    itemId: 113,
    blendMode: 'no-blend',
    majorLayer: true,
  },
  {
    src: asset11,
    x: 48.8655,
    y: 210.1746,
    itemId: 107,
    excludeSportId: 'softball-ncaa',
  },
  {
    src: lacesSB,
    x: 48.9597,
    y: 210.5802,
    itemId: 107,
    sportId: 'softball-ncaa',
  },
]

const flippedAssets = [
  {
    src: asset9Flip,
    x: 33.0319,
    y: 283.0101,
    itemId: 116,
    blendMode: 'no-blend',
    assetIndex: 8,
  },
]

const data = {
  assets,
  flippedAssets,
}

export default data
